var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-page',{key:"preguntasFrecuentes",staticClass:"app-bg"},[_c('div',{staticClass:"row flex-center full-width"},[_c('PreguntasFrecuentesComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }